var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoMcube = function SvgLogoMcube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 98 94"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_mcube_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F39222",
    d: "m55.5 14 29.305-5.445c2.81-.522 5.497 1.255 6.002 3.97l7.137 38.415c.505 2.715-1.364 5.339-4.175 5.86l-29.304 5.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A72B9",
    d: "M79 84c-.784 1.142-1.647 1.62-3.009 1.873l-43.385 8.043a5.214 5.214 0 0 1-6.078-4.174v-.014l-8.026-43.385a5.22 5.22 0 0 1 4.18-6.084h.014l15.8-2.941h.027l20.634-3.823 6.921-1.286a5.22 5.22 0 0 1 6.08 4.188L73.76 45l3.74 22.5c.953 6.034 1.748 10.263 2 13 .145 1.572-.26 3.15-.5 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#76B947",
    d: "m55.529 14.028-15.501 2.877a5.6 5.6 0 0 0-.925.253l-.013-.004a5.4 5.4 0 0 0-1.855 1.234 4.5 4.5 0 0 0-.555.672 5.15 5.15 0 0 0-.84 3.91l.17.91 2.508 13.434h-.027l-15.8 2.931a5.22 5.22 0 0 0-4.178 6.086l2.6 14.174-6.903 1.274a5.223 5.223 0 0 1-6.09-4.182v-.006L.09 14.233a5.223 5.223 0 0 1 4.17-6.1h.019L47.664.09a5.22 5.22 0 0 1 6.087 4.177z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D953F",
    d: "M59.152 33.492 38.518 37.31 36.01 23.889l-.171-.911a5.15 5.15 0 0 1 .84-3.909q.245-.362.555-.672a5.4 5.4 0 0 1 1.855-1.234.03.03 0 0 0 .027 0q.444-.163.91-.249l15.5-2.874z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_mcube_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h98v94H0z"
  })))));
};
export default SvgLogoMcube;